import { ProTable } from '@ant-design/pro-components'
import { PatientMobilityEditDrawer } from '@app/icare/entities/patient/edits/PatientMobilityEditDrawer'
import { patientMobilityQueries } from '@app/icare/entities/patient/queries/patientMobilityQueries'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { MobilityEnum } from '@app/icare/entities/patient/schema/PatientMobility'
import { sortByActiveRange } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button } from 'antd'
import { FaPencil } from 'react-icons/fa6'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese/mobilitaet')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientMobilityQueries.forList(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()
  const { data: mobilities = [] } = useSuspenseQuery(patientMobilityQueries.forList(patientId))

  return (
    <ProTable
      search={false}
      options={false}
      rowKey="id"
      size="small"
      dataSource={mobilities}
      locale={{ emptyText: t`Keine Mobilitäten vorhanden` }}
      columns={[
        {
          title: t`Mobilität`,
          dataIndex: 'mobility',
          render: (_, r) => MobilityEnum.$.getLabel(r.mobility),
        },
        {
          title: t`Gültig von`,
          dataIndex: 'activeFrom',
          valueType: 'date',
          defaultSortOrder: 'descend',
          sorter: sortByActiveRange,
        },
        {
          title: t`Gültig bis`,
          dataIndex: 'activeTo',
          valueType: 'date',
        },
        {
          valueType: 'option',
          render: (_t, r) => [
            <Button
              key="edit"
              type="text"
              size="small"
              icon={<FaPencil />}
              onClick={() => PatientMobilityEditDrawer.show({ patientId, relationId: r.id })}
            />,
          ],
        },
      ]}
    />
  )
}
